import styled from 'styled-components';

import { 
  BACKGROUND_CALENDAR, COLOR_CALENDAR_FREE, COLOR_CALENDAR_OCCUPIED,  COLOR_CALENDAR_BLOCKED, COLOR_CALENDAR_HOLIDAY, FONT_SIZE_CALENDAR_LEGEND_TEXT, FONT_SIZE_CALENDAR_LEGEND_ICON
} from '../../../globals';


export const StyledLegend = styled.div`
  font-weight: 400;
  margin-top: 10px;

  span {
    font-size: ${FONT_SIZE_CALENDAR_LEGEND_TEXT}em;
  }

  li:after {
    content: '';
    padding-right: 10px;
  }

  i {
    font-size: ${FONT_SIZE_CALENDAR_LEGEND_ICON}em;
  }

  .calendar-legend-free {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_FREE};
  }

  .calendar-legend-occupied {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_OCCUPIED};
    cursor: default;
  }

  .calendar-legend-blocked {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_BLOCKED};
    cursor: default;
  }

  .calendar-legend-holiday {
    background-color: ${BACKGROUND_CALENDAR};
    color: ${COLOR_CALENDAR_HOLIDAY};
    cursor: default;
  }

`;
